'use client';
import Link from 'next/link';
import React from 'react';
import get from 'lodash/get';
import { checkType } from '@/common/ultils';
import Image from 'next/image';
// import Image from 'next/image';

const removeImagesFromHTML = (html = '') => {
  return html.replace(/<img[^>]*>/gi, '');
};
const PostsMain = ({ featuredEvents, deviceType }) => {
  const mainPost = get(featuredEvents, 'results[0]');
  const mainImageUrl = mainPost ? checkType(deviceType === 'mobile' ? 'mobile' : 'tablet', mainPost) : null;

  if (!mainPost) {
    return null;
  }

  return (
    <div className="space-y-3 group">
      <div className="relative">
        <Link href={`${mainPost?.menu?.slug}/${mainPost.slug}`} className="block">
          {mainImageUrl && (
            <div className="relative overflow-hidden h-48 sm:h-56 md:h-64 lg:h-60 xl:h-72">
              <Image
                src={mainImageUrl}
                alt={mainPost.title}
                fill
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                className="object-cover rounded-t group-hover:scale-105 transition-transform duration-300"
                priority
                quality={85}
              />
              {/* <img
                src={mainImageUrl}
                alt={mainPost.title}
                className="w-full h-48 sm:h-56 md:h-64 lg:h-60 xl:h-72 object-cover rounded-t group-hover:scale-105 transition-transform duration-300"
              /> */}
            </div>
          )}
        </Link>
      </div>

      <div className="px-2 sm:px-4 lg:px-1">
        <Link href={`${mainPost?.menu?.slug}/${mainPost.slug}`} className="">
          <h3 className="text-md sm:text-base lg:text-base font-bold group-hover:text-red-700 transition-colors mb-2 line-clamp-2 text-black">
            {mainPost.title}
          </h3>
        </Link>

        <div className="text-[13px] text-black line-clamp-4 sm:line-clamp-5 leading-relaxed">
          {mainPost?.summary ? (
            <div
              className="boldish-text text-justify group-hover:text-red-700!"
              dangerouslySetInnerHTML={{ __html: removeImagesFromHTML(mainPost?.summary) }}
            />
          ) : (
            <div
              className="space-y-1 desc-post boldish-text group-hover:text-red-700!"
              dangerouslySetInnerHTML={{ __html: removeImagesFromHTML(mainPost?.content) ?? '' }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PostsMain;
